import { render } from "./FormularioCadastro.vue?vue&type=template&id=3a00faa0"
import script from "./FormularioCadastro.vue?vue&type=script&lang=js"
export * from "./FormularioCadastro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__